import React, { Suspense } from "react";
import { Node_Type } from "./../../ricos-types/index.js";
const Poll = React.lazy(() => import(
  /* webpackChunkName: "ricos_plugin_poll_lazy" */
  "./poll.js"
));
const PollRenderer = ({
  node,
  nodeIndex,
  NodeViewContainer,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement(
    Poll,
    {
      key: node.id,
      node,
      nodeIndex,
      NodeViewContainer,
      ...props
    }
  );
};
const PollLazy = ({ node, nodeIndex, NodeViewContainer, ...props }) => {
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(
    PollRenderer,
    {
      node,
      nodeIndex,
      NodeViewContainer,
      ...props
    }
  ));
};
const nodeViewRenderers = {
  [Node_Type.POLL]: PollLazy
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers-lazy.js.map
